import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMyProjects = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	"data-name": "Layer 1",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 25 25",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: "\n      .my-projects-cls-2 {\n        fill: transparent;\n      }\n\n      .my-projects-cls-3 {\n        fill: currentColor;\n      }\n\n      .my-projects-cls-4 {\n        fill: currentColor;\n      }\n    " }) }),
		/* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", {
			className: "my-projects-cls-2",
			d: "M24.357,25H.643A.643.643,0,0,1,0,24.357V.644A.643.643,0,0,1,.643,0H24.357A.643.643,0,0,1,25,.644V24.357A.643.643,0,0,1,24.357,25Z"
		}) }),
		/* @__PURE__ */ _jsx("rect", {
			className: "my-projects-cls-3",
			x: 5.523,
			y: 16.884,
			width: 13.955,
			height: 2.594
		}),
		/* @__PURE__ */ _jsx("rect", {
			className: "my-projects-cls-3",
			x: 5.523,
			y: 11.203,
			width: 15.67,
			height: 2.594
		}),
		/* @__PURE__ */ _jsx("rect", {
			className: "my-projects-cls-3",
			x: 5.523,
			y: 5.523,
			width: 19.477,
			height: 2.594
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "my-projects-cls-4",
			d: "M23.714,11.2V23.714H1.287V1.286H23.714v1.15H25V.643A.643.643,0,0,0,24.357,0H.644A.643.643,0,0,0,0,.643V24.357A.643.643,0,0,0,.644,25H24.357A.643.643,0,0,0,25,24.357V11.2Z"
		})
	]
});
export default SvgMyProjects;
